import { useCallback, useEffect } from 'react';
import type { FieldValues, Path, UseFormSetValue, UseFormWatch } from 'react-hook-form';

type UseLoginEmailFieldParams<T extends FieldValues> = {
  initialEmail: string;
  onEmailChange?: (email: string) => void;
  setValue: UseFormSetValue<T>;
  watch: UseFormWatch<T>;
};

export const useLoginEmailField = <T extends FieldValues & { email: string }>(params: UseLoginEmailFieldParams<T>) => {
  const { initialEmail, onEmailChange, setValue, watch } = params;
  const normalizedInitialEmail = initialEmail ?? '';
  const email = watch('email' as Path<T>) ?? '';

  useEffect(() => {
    setValue('email' as Path<T>, normalizedInitialEmail as T[Path<T>]);
  }, [normalizedInitialEmail, setValue]);

  const onEmailInputChange = useCallback(
    (value: string) => {
      setValue('email' as Path<T>, value as T[Path<T>]);
      onEmailChange?.(value);
    },
    [onEmailChange, setValue],
  );

  return { email, onEmailInputChange };
};

export default useLoginEmailField;
